module.exports = __webpack_public_path__ + "img/horizontal-spacing.6882a1e8.svg";